import { render, staticRenderFns } from "./UserTableList.vue?vue&type=template&id=4c4bfc64"
import script from "./UserTableList.vue?vue&type=script&lang=js"
export * from "./UserTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports